<script>
	export let component = false
	import Connector from '@comp/Connector'
	import Console from '@comp/Console'
	import Controls from '@comp/Controls'
	import JsState from '@comp/JsState'
	import State from '@comp/State'
	import Stream from '@comp/Stream'
	import XmlState from '@comp/XmlState'

	const widgets = {
		Connector,
		Controls,
		Stream,
		Console,
		State,
		JsState,
		XmlState,
	}

	const list = Object.entries(widgets)
		.map(([key, component]) => ({key, component}))

	$: active = widgets[component]
</script>

<section>
	<ul>
	{#each list as widget}
		<li>
			<button
				class:active={component === widget.key}
				on:click={() => component = widget.key} >
					{widget.key}
			</button>
		</li>
	{/each}
	</ul>
	<svelte:component this={active} />
</section>

<style>
	button {
		font-size: var(--text-base);
		border: none;
		color: var(--azure);
		background: var(--white);
		cursor: pointer;
	}

	button:hover, button:focus {
		color: var(--black);
	}

	button.active {
		color: var(--orange);
	}

	ul {
		list-style: none;
		display: flex;
		gap: var(--spacing-sm);

		margin-bottom: var(--spacing-sm);
	}
</style>
